import { render, staticRenderFns } from "./service-switch.vue?vue&type=template&id=349579ed&"
import script from "./service-switch.vue?vue&type=script&lang=js&"
export * from "./service-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports